import { useEffect, useState } from "react";
import { FileText } from "lucide-react";

interface Props {
  file: File | null;
}

export function PDFPreview({ file }: Props) {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    if (file) {
      const url = URL.createObjectURL(file);
      setObjectUrl(url);
      return () => URL.revokeObjectURL(url);
    } else {
      setObjectUrl(null);
    }
  }, [file]);

  if (!file || !objectUrl) {
    return (
      <div className="flex flex-col items-center justify-center h-64 text-muted-foreground">
        <FileText className="w-12 h-12 mb-2" />
        <p className="text-sm">No PDF uploaded</p>
      </div>
    );
  }

  return (
    <div className="w-full h-[400px] border rounded-lg overflow-hidden bg-muted">
      <iframe
        src={objectUrl}
        title={file.name}
        className="w-full h-full"
      />
    </div>
  );
}
